// Do not modify, this file was generated
export type SassyColorNames =
    | 'sassyColorAlertPrimary'
    | 'sassyColorAlertSecondary'
    | 'sassyColorWarningPrimary'
    | 'sassyColorWarningSecondary'
    | 'sassyColorSuccessPrimary'
    | 'sassyColorSuccessSecondary'
    | 'sassyColorSuccessTertiary'
    | 'sassyColorBuyerPrimary'
    | 'sassyColorBuyerSecondary'
    | 'sassyColorBuyerTertiary'
    | 'sassyColorBuyerTertiaryAlt'
    | 'sassyColorBuyerPrimaryIphone'
    | 'sassyColorDealerPrimary'
    | 'sassyColorDealerSecondary'
    | 'sassyColorDealerTertiary'
    | 'sassyColorDealerTertiaryAlt'
    | 'sassyColorWhite'
    | 'sassyColorAlabaster'
    | 'sassyColorMoonstone'
    | 'sassyColorDolphin'
    | 'sassyColorStorm'
    | 'sassyColorIron'
    | 'sassyColorSatan'
    | 'sassyColorCharcoal'
    | 'sassyColorNoir'
    | 'sassyColorPitchBlack'
    | 'sassyColorOverlayBackground'
    | 'sassyColorOverlayLight'
    | 'sassyColorInternalPrimary'
    | 'sassyColorInternalSecondary'
    | 'sassyColorInternalTertiary'
    | 'sassyColorMarketingSale'
    | 'sassyColorMedalBronze'
    | 'sassyColorMedalSilver'
    | 'sassyColorMedalGold'
    | 'sassyColorMedalPlatinum'
    | 'sassyColorPinterestPrimary'
    | 'sassyColorFacebookPrimary'
    | 'sassyColorInstagramPrimary'
    | 'sassyColorLinkedinPrimary'
    | 'sassyColorTwitterPrimary'
    | 'sassyColorDesignManagerPrimary'
    | 'sassyColorDesignManagerSecondary'
    | 'sassyColorDesignManagerTertiary'
    | 'sassyColorTradePrimary'
    | 'sassyColorTradeSecondary'
    | 'sassyColorTradeTertiary';

export type SassyColorValues =
    | '#CC0000'
    | '#950808'
    | '#F07F04'
    | '#FFC100'
    | '#66a559'
    | '#2A7140'
    | '#aedfa3'
    | '#C2A661'
    | '#A48E45'
    | '#F6F3EB'
    | '#E8DFCD'
    | '#CCA738'
    | '#436B93'
    | '#204664'
    | '#DEE3EB'
    | '#D8ECF5'
    | '#FFF'
    | '#FBFBFB'
    | '#F3F3F3'
    | '#DDD'
    | '#BBB'
    | '#888'
    | '#666'
    | '#444'
    | '#222'
    | '#000'
    | 'rgba(0, 0, 0, 0.7)'
    | 'rgba(255, 255, 255, 0.4)'
    | '#559B5E'
    | '#2A7140'
    | '#B8E7C8'
    | '#950808'
    | '#b57638'
    | '#8C9BA8'
    | '#C2A661'
    | '#757686'
    | '#E00002'
    | '#3B5998'
    | '#275A85'
    | '#007BB6'
    | '#4099FF'
    | '#4BC7E7'
    | '#4F8BC0'
    | '#45545F'
    | '#0F8D88'
    | '#0D7D77'
    | '#E7F4F3';

export type SassyColors = Record<SassyColorNames, SassyColorValues>;

export const colors: SassyColors = {
    sassyColorAlertPrimary: '#CC0000',
    sassyColorAlertSecondary: '#950808',
    sassyColorWarningPrimary: '#F07F04',
    sassyColorWarningSecondary: '#FFC100',
    sassyColorSuccessPrimary: '#66a559',
    sassyColorSuccessSecondary: '#2A7140',
    sassyColorSuccessTertiary: '#aedfa3',
    sassyColorBuyerPrimary: '#C2A661',
    sassyColorBuyerSecondary: '#A48E45',
    sassyColorBuyerTertiary: '#F6F3EB',
    sassyColorBuyerTertiaryAlt: '#E8DFCD',
    sassyColorBuyerPrimaryIphone: '#CCA738',
    sassyColorDealerPrimary: '#436B93',
    sassyColorDealerSecondary: '#204664',
    sassyColorDealerTertiary: '#DEE3EB',
    sassyColorDealerTertiaryAlt: '#D8ECF5',
    sassyColorWhite: '#FFF',
    sassyColorAlabaster: '#FBFBFB',
    sassyColorMoonstone: '#F3F3F3',
    sassyColorDolphin: '#DDD',
    sassyColorStorm: '#BBB',
    sassyColorIron: '#888',
    sassyColorSatan: '#666',
    sassyColorCharcoal: '#444',
    sassyColorNoir: '#222',
    sassyColorPitchBlack: '#000',
    sassyColorOverlayBackground: 'rgba(0, 0, 0, 0.7)',
    sassyColorOverlayLight: 'rgba(255, 255, 255, 0.4)',
    sassyColorInternalPrimary: '#559B5E',
    sassyColorInternalSecondary: '#2A7140',
    sassyColorInternalTertiary: '#B8E7C8',
    sassyColorMarketingSale: '#950808',
    sassyColorMedalBronze: '#b57638',
    sassyColorMedalSilver: '#8C9BA8',
    sassyColorMedalGold: '#C2A661',
    sassyColorMedalPlatinum: '#757686',
    sassyColorPinterestPrimary: '#E00002',
    sassyColorFacebookPrimary: '#3B5998',
    sassyColorInstagramPrimary: '#275A85',
    sassyColorLinkedinPrimary: '#007BB6',
    sassyColorTwitterPrimary: '#4099FF',
    sassyColorDesignManagerPrimary: '#4BC7E7',
    sassyColorDesignManagerSecondary: '#4F8BC0',
    sassyColorDesignManagerTertiary: '#45545F',
    sassyColorTradePrimary: '#0F8D88',
    sassyColorTradeSecondary: '#0D7D77',
    sassyColorTradeTertiary: '#E7F4F3',
};
